function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M33.406,56.276A81.8,81.8,0,0,1,25.762,41.59C21.005,30.159,54.7,19.831,41.03,0c5.924,13.708-21.248,22.171-23.771,33.593C14.941,44.085,33.391,56.276,33.406,56.276Z",
  transform: "translate(8.13 0.002)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M24.958,25.555c-.541,6.782,6.254,10.4,6.448,15.337.157,4.031-4.061,7.385-4.061,7.385S35,46.84,37.389,40.685c2.652-6.823-5.14-11.485-4.35-16.948C33.8,18.51,49.968,8.811,49.968,8.811S26.171,10.319,24.958,25.555ZM47.973,46.521c4.918-1.06,9.072,1.948,9.072,5.418,0,7.807-11.28,15.186-11.28,15.186s17.468-2,17.468-14.824C63.233,43.828,54.652,41.715,47.973,46.521Z",
  transform: "translate(17.215 10.175)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M58,33.96s5.448-3.727,6.9-5.119c-13.361,2.723-43.863,3.085-43.863.726,0-2.174,9.83-4.414,9.83-4.414s-21.8-.3-21.8,5.873C9.065,37.47,37.613,37.924,58,33.96Z",
  transform: "translate(-1.098 29.038)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_145",
  "data-name": "Path 145",
  d: "M50.255,33.389c-12.64,4.046-35.946,2.749-29.047-2.667-3.348,0-8.337,2.59-8.337,5.078,0,5.009,25.191,8.865,43.839,1.549Z",
  transform: "translate(3.296 35.469)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M22.231,35.922c-4.584,0-7.56,2.833-7.56,4.912,0,6.431,27.378,7.079,38.227.541L46,36.986C37.9,40.414,17.551,40.877,22.231,35.922Z",
  transform: "translate(5.375 41.471)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M81.9,43.584c0-2.514-2.96-3.708-4.029-4.279,6.25,14.473-62.589,13.348-62.589,4.811,0-1.948,5.056-3.85,9.748-2.941l-3.981-2.26C11.708,37.5,5.366,41.438,5.366,44.62,5.364,59.433,81.9,58.72,81.9,43.584Z",
  transform: "translate(-5.366 44.586)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M82.559,43.25C70.926,54.278,41.435,58.3,11.782,51.486,41.433,63.617,82.413,56.792,82.559,43.25Z",
  transform: "translate(2.04 49.931)"
});

function SvgJava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-java",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.6,
    height: 107.719,
    viewBox: "0 0 84.6 107.719",
    transform: "translate(0 -8)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/Java.bb93a4a8.svg";
export { ForwardRef as ReactComponent };